import { ArrowRightIcon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

import { CaseAlertList } from './case-alert-list/case-alert-list'
import { SetAlertsDialog } from './dialogs/set-alerts-dialog/set-alerts-dialog'
import { useCaseAlerts } from './use-case-alerts'

export interface CaseAlertsProps {
  wrapperDivClassName?: string
  showsLabel?: boolean
}

export const CaseAlerts = ({ wrapperDivClassName, showsLabel = false }: CaseAlertsProps) => {
  const { isSetAlertsDialogOpen, openSetAlertsDialog, closeSetAlertsDialog } = useCaseAlerts()

  return (
    <>
      <div className={cn(wrapperDivClassName)}>
        {showsLabel && <h3 className={cn('text-base font-medium')}>Track important dates</h3>}
        <div
          className={cn('space-y-3', {
            'mt-[18px]': showsLabel,
          })}
        >
          <Button variant="outline" className={cn('h-[56px] w-full', 'py-4')} onClick={openSetAlertsDialog}>
            <p className={cn('mr-auto')}>Set Other Alerts</p>
            <ArrowRightIcon size={24} />
          </Button>

          <CaseAlertList />
        </div>
      </div>

      {isSetAlertsDialogOpen && <SetAlertsDialog open={isSetAlertsDialogOpen} onClose={closeSetAlertsDialog} />}
    </>
  )
}
